import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "aiList mainBox" }
const _hoisted_2 = { class: "aiItem maria" }
const _hoisted_3 = { class: "aiItem maria" }
const _hoisted_4 = { class: "aiItem maria" }

import {} from "vue";
import { navTo } from "@/utils/util";

export default /*@__PURE__*/_defineComponent({
  __name: 'aiProduct',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_OssImg = _resolveComponent("OssImg")!

  return (_openBlock(), _createElementBlock("div", {
    class: "aiBox homeWrap wow animate__animated animate__fadeIn",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(navTo)('/product/ai')))
  }, [
    _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"title\" style=\"text-align:center;\" data-v-4ba540d4><div class=\"text1\" data-v-4ba540d4>AI产品</div><div class=\"text2\" data-v-4ba540d4>实验室安全，AI “智” 在必得</div></div><div class=\"subTitle\" data-v-4ba540d4><div data-v-4ba540d4>实时监控无死角</div><div class=\"line\" data-v-4ba540d4></div><div data-v-4ba540d4>风险预警秒响应</div><div class=\"line\" data-v-4ba540d4></div><div data-v-4ba540d4>让每一次实验都安心启航</div></div>", 2)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_OssImg, {
          src: "/UIV3/aiIcon.png",
          alt: "",
          class: "aiIcon"
        }),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "aiItemTitle" }, "智能体", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "aiItemText" }, " 智能巡检预警隐患、管理危废全流程、调度应急、监管行为，还能分析数据辅助决策 ", -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_OssImg, {
          src: "/UIV3/aiIcon.png",
          alt: "",
          class: "aiIcon"
        }),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "aiItemTitle" }, "AI智慧问答", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "aiItemText" }, " 快速解答危废处置流程、安全检查标准、设备操作规范等常见问题，精准解析复杂提问 ", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_OssImg, {
          src: "/UIV3/aiIcon.png",
          alt: "",
          class: "aiIcon"
        }),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "aiItemTitle" }, "行为算法", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "aiItemText" }, " 精准识别违规行为，发现异常立即发出警报，有效降低人为失误引发的安全风险，提升实验室安全管理效率 。 ", -1))
      ])
    ])
  ]))
}
}

})